import { render } from "./ThemesManager.vue?vue&type=template&id=22190690"
import script from "./ThemesManager.vue?vue&type=script&lang=js"
export * from "./ThemesManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__